import { Filter } from 'lucide-react';

import { HabilitationsTunnelsManager } from 'back-office/features/plateformes-view/habilitations-tunnels/components/HabilitationsTunnelsManager';
import { useCurrentAccess } from 'features/access/hooks/useCurrentAccess';
import { GenericLoading } from 'components/ui/Loader';

/**
 * Espace compagnie : matrice d'habilitation des courtiers sur les tunnels de
 * SON plateforme. Réutilise le composant du BO — les gardes backend
 * (Owner de la PM principale) s'appliquent à l'identique.
 */
export default function MesHabilitationsTunnelsPage() {
  const { plateformes, isReady } = useCurrentAccess();

  if (!isReady) {
    return <GenericLoading loading isParentSized />;
  }

  const ownedPlateforme = plateformes.find((o) => o.gouverne);

  if (!ownedPlateforme) {
    return (
      <div className="p-6">
        <div className="bg-white rounded-2xl border border-gray-200 p-12 text-center">
          <Filter className="mx-auto text-gray-300 mb-2" size={32} />
          <p className="text-sm text-gray-500">
            Votre personne morale n&apos;est la personne morale principale
            d&apos;aucune plateforme.
          </p>
          <p className="text-xs text-gray-400 mt-1">
            La gestion des habilitations tunnels est réservée à la PM principale.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6">
      <HabilitationsTunnelsManager plateformeId={ownedPlateforme.plateformeId} />
    </div>
  );
}
